// Helper function to parse a number or fraction
export const parseNumber = (value) => {
  if (!value) return null;
  
  // Check if it's a fraction
  if (value.includes('/')) {
    const [numerator, denominator] = value.split('/').map(Number);
    if (isNaN(numerator) || isNaN(denominator) || denominator === 0) return null;
    return numerator / denominator;
  }
  
  // Try parsing as a regular number
  const num = Number(value);
  return isNaN(num) ? null : num;
}; 